import { TopChartCard } from './TopChartCard'
import { withTopChartCard } from './withTopChartCard'

const ConnectedTopChartCard = withTopChartCard(TopChartCard)

export { ConnectedTopChartCard as TopChartCard }
